var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1644F9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.302.25C14.93.25 19.5 4.617 19.5 10.015c0 5.398-4.57 9.764-10.198 9.764-3.247 0-6.243-1.463-8.158-3.904-.17-.217-.132-.531.085-.702.217-.17.531-.132.702.085 1.726 2.2 4.432 3.521 7.371 3.521 5.085 0 9.198-3.929 9.198-8.764 0-4.836-4.113-8.765-9.198-8.765-2.96 0-5.683 1.341-7.407 3.567-.169.218-.483.258-.701.09-.218-.17-.258-.484-.09-.702C3.018 1.735 6.033.25 9.303.25zm.731 6.03c.129-.126.317-.162.48-.102l.087.045.073.057 3.46 3.403c.13.127.166.313.1.48l-.041.083-.059.07-3.46 3.404c-.086.084-.2.13-.32.13-.119 0-.234-.046-.32-.13-.128-.127-.166-.314-.1-.481l.042-.082.058-.071 2.613-2.571-9.778.002c-.17 0-.319-.1-.401-.254l-.036-.081-.023-.09L2.4 10c0-.213.118-.402.3-.48l.082-.028.086-.009h9.777l-2.612-2.569c-.107-.105-.15-.253-.124-.396l.024-.085.042-.081.058-.072z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.835f9046.svg";
export { ForwardRef as ReactComponent };